import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { strings } from '@constants'
import { Spacings } from '@styles'
import { updateOrganisationApi } from '@data/conn/put/organisation'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Input } from '@baseV2'

import { InputsWrapper } from '../styles'

const FooterActions = styled.div`
	display: flex;
	width: 100%;
	gap: ${Spacings.SPACING_3B};
	justify-content: flex-end;
`

const EditInsuredAmount = ({ orgDetails, update }) => {
	const dispatch = useDispatch()
	const [insuredAmount, setInsuredAmount] = useState(orgDetails?.insured_amount ?? '')

	useEffect(() => {
		setInsuredAmount(orgDetails?.insured_amount ?? '')
	}, [orgDetails])

	const onInsuredAmountUpdate = () => {
		if (insuredAmount === '' || insuredAmount === null) return
		dispatch(showLoader(true))
		updateOrganisationApi(orgDetails?.organisation_id, 'INSURED_AMOUNT', Number(insuredAmount))
			.then(() => {
				dispatch(showToast(true, strings('organisation_update_success'), { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update()
			})
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, strings('organisation_update_failure'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Input
						id='insured-amount-v2'
						type='number'
						label='Insured Amount'
						placeholder={strings('enter', 'amount')}
						value={insuredAmount}
						onChange={(e) => setInsuredAmount(e.target.value)}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<FooterActions>
					<Button variant='outline' color='danger' onClick={() => dispatch(toggleDrawer(false))}>
						{strings('cancel')}
					</Button>
					<Button color='primary' disabled={insuredAmount === '' || insuredAmount === null} onClick={onInsuredAmountUpdate}>
						{strings('update')}
					</Button>
				</FooterActions>
			</DrawerFooterWrapper>
		</>
	)
}

export default EditInsuredAmount
